<template>
    <a
        :href="data.link"
        class="social-icon"
        :aria-label="`${data.name} - opens in a new tab`"
        target="_blank"
    >
        <Icon
            v-if="icon"
            :icon="icon"
        />
    </a>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { SocialNetworkFragment } from '@/graphql/api'
import { cmsIconToThIcon } from '@/helpers/icon'

import Icon from '@/components/ui/icon/Icon.vue'

const props = defineProps<{
    data: SocialNetworkFragment
}>()

const icon = computed(() => cmsIconToThIcon(props.data.icon))
</script>

<style lang="scss" scoped>
.social-icon {
    margin: 0 2px;
    flex: 0 0 48px;
    height: 48px;
    padding: 6px;
    cursor: pointer;

    .icon {
        width: 36px;
        height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: $border-dark-grey;
        border-radius: 100%;
        font-family: $icon-font;
        text-decoration: none;
        color: $slate;

        &.facebook::before {
            content: $icon-facebook;
        }

        &.pinterest::before {
            content: $icon-pinterest;
        }

        &.instagram::before {
            content: $icon-instagram;
        }

        &.twitter::before {
            content: $icon-twitter;
        }

        &.youtube::before {
            content: $icon-youtube;
        }
    }
}
</style>
